"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.turndown = turndown;
const turndown_1 = __importDefault(require("turndown"));
const language_1 = require("./language");
const { tables } = require('turndown-plugin-gfm');
function getTextWithLineBreaks(node) {
    let text = '';
    for (const childNode of node.childNodes) {
        if (childNode.nodeType === 3) {
            // NODE.TEXT_NODE
            text += childNode.textContent;
        }
        else if (childNode.nodeName === 'BR') {
            text += '\n';
        }
        else if (childNode.nodeType === 1) {
            // NODE.ELEMENT_NODE
            text += getTextWithLineBreaks(childNode);
        }
    }
    return text;
}
function addCustomRules(service) {
    service.addRule('fencedCodeBlockWithCodeElement', {
        filter(node, options) {
            return Boolean(options.codeBlockStyle === 'fenced' &&
                node.nodeName === 'PRE' &&
                node.firstChild &&
                node.firstChild.nodeName === 'CODE');
        },
        replacement(content, node, options) {
            var _a, _b, _c;
            node = node;
            const className = [node.className, (_a = node.firstElementChild) === null || _a === void 0 ? void 0 : _a.className].join(' ');
            const language = ((_b = node.dataset) === null || _b === void 0 ? void 0 : _b.language) || ((_c = node.dataset) === null || _c === void 0 ? void 0 : _c.lang) || node.getAttribute('data-language') || node.getAttribute('data-lang') || (0, language_1.detectLanguage)(className);
            const code = node.textContent || '';
            const fence = options.fence;
            return ('\n\n' + fence + language + '\n' +
                code.replace(/\n$/, '') +
                '\n' + fence + '\n\n');
        }
    });
    service.addRule('fencedCodeBlockWithoutCodeElement', {
        filter(node, options) {
            var _a;
            return Boolean(options.codeBlockStyle === 'fenced' &&
                node.nodeName === 'PRE' &&
                ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.nodeName) !== 'CODE');
        },
        replacement(content, node, options) {
            var _a, _b, _c, _d;
            node = node;
            const className = [node.className, (_a = node.firstElementChild) === null || _a === void 0 ? void 0 : _a.className, (_b = node.parentElement) === null || _b === void 0 ? void 0 : _b.className].join(' ');
            const language = ((_c = node.dataset) === null || _c === void 0 ? void 0 : _c.language) || ((_d = node.dataset) === null || _d === void 0 ? void 0 : _d.lang) || node.getAttribute('data-language') || node.getAttribute('data-lang') || (0, language_1.detectLanguage)(className);
            const code = getTextWithLineBreaks(node) || '';
            const fence = options.fence;
            return ('\n\n' + fence + language + '\n' +
                code.replace(/\n$/, '') +
                '\n' + fence + '\n\n');
        }
    });
}
function turndown(text, options) {
    const customTurndownService = new turndown_1.default({
        emDelimiter: '*',
        codeBlockStyle: 'fenced',
        fence: '```',
        headingStyle: 'atx',
        bulletListMarker: '+',
        ...options
    });
    customTurndownService.use([tables]);
    addCustomRules(customTurndownService);
    return customTurndownService.turndown(text);
}
